export default __webpack_public_path__ + "static/media/CardButtonRightArrow.098326d0.svg";